import { render, staticRenderFns } from "./Nutrifacts.vue?vue&type=template&id=04279994&"
import script from "./Nutrifacts.vue?vue&type=script&lang=js&"
export * from "./Nutrifacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports